import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModulosService } from 'src/app/services/modulos.service';
import { operacion_moduloJoin } from 'src/app/shared/object/operacion_moduloJoin.model';
import { operacion } from 'src/app/shared/object/operaciones.model';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { modulo } from '../../../shared/object/modulo.model';
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';

@Component({
  selector: 'app-modulos',
  templateUrl: './modulos.component.html',
  styleUrls: ['./modulos.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class ModulosComponent implements OnInit {
  private client: GraphQLClient = null;
  moduloList: modulo[];
  selectedModulo: modulo;
  operacionModuloList: operacion_moduloJoin[];
  operacionList: operacion[];
  optionsOperacion: Array<any> = [];
  modulo: modulo;
  public filtroNombre: string;
  formulario: FormGroup;
  @ViewChild('agregarModulo', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarModulo', { static: true }) editarModal: ModalDirective;
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  public codgo_modulo: number = 23;
  public rut_usuario = Number(this.accesolocalstorage.getRutUsuario());
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false

  // Utils
  private log: any

  constructor(client: GraphQLClient,
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    private moduloService: ModulosService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private clog: ConsoleService,
  ) {
    this.client = client;
    this.buildForm();
    this.log = this.clog.log('MODULOS')
  }

  buildForm() {
    this.formulario = this.formBuilder.group({
      codigo: [0],
      nombre: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      activado: [true],
      categoria_modulo_codigo: [0],
      endpoint: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
      orden: [[Validators.required], Validators.min(1)],
      operacion: [''],
      habilitar_bloqueo: [false]
    });
  }

  ngOnInit() {
    this.paginationContext.RecordsByPage = 10
    this.selectedModulo = {
      codigo: 0,
      nombre: '',
      activado: true,
      fecha_creacion: new Date(),
      categoria_modulo_codigo: 0,
      endpoint: '',
      orden: 0,
      habilitar_bloqueo: false
    };
    //this.obtenerDatosModulo();
    this.obtenerOperacion();
  }

  showNew() {
    this.formulario.reset();
    this.formulario.get('activado').setValue(true);
    this.operacionModuloList = [];
  }

  showForEdit(modulo: modulo) {
    this.formulario.get('codigo').setValue(modulo.codigo);
    this.formulario.get('nombre').setValue(modulo.nombre);
    this.formulario.get('activado').setValue(modulo.activado);
    this.formulario.get('categoria_modulo_codigo').setValue(modulo.categoria_modulo_codigo);
    this.formulario.get('endpoint').setValue(modulo.endpoint);
    this.formulario.get('orden').setValue(modulo.orden);
    this.formulario.get('habilitar_bloqueo').setValue(modulo.habilitar_bloqueo);
    this.formulario.get('operacion').setValue("");
    this.obtenerOperacionModulo(modulo.codigo);
  }

  obtenerTodosModulo(pageNumber: number = 1) {
    this.paginationContext.CurrentPage = pageNumber
    this.moduloList = null
    const inputParams =
    {
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.log('inputParams', JSON.stringify(inputParams))

    this.moduloService.obtenerTodosModulo(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.moduloList = registros;
    });
  }

  insertar(operacionModuloList: operacion_moduloJoin[]) {
    this.selectedModulo.nombre = this.formulario.controls["nombre"].value;
    this.selectedModulo.categoria_modulo_codigo = this.formulario.controls["categoria_modulo_codigo"].value;
    this.selectedModulo.endpoint = this.formulario.controls["endpoint"].value;
    this.selectedModulo.activado = this.formulario.controls["activado"].value;
    this.selectedModulo.orden = this.formulario.controls["orden"].value;
    this.selectedModulo.habilitar_bloqueo = this.formulario.controls["habilitar_bloqueo"].value;
    this.postModulo(this.selectedModulo, operacionModuloList);
  }

  postModulo(modulo: modulo, operacionModuloList: operacion_moduloJoin[]) {
    let self = this;
    var bodyx = modulo;
    //var self = this;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: moduloInputType)
      {
        modulo
        {
          agregar(entidad: $entidad) {
            respuesta{
              codigo
              categoria_modulo_codigo
              nombre
              activado
              fecha_creacion
              endpoint
              orden
              habilitar_bloqueo
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.modulo.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerTodosModulo(), 1000);
          let codigo_modulo = respuesta.data.modulo.agregar.respuesta.codigo;
          self.insertarOperacion(operacionModuloList, codigo_modulo);
        }
      });
  }

  buscar(pageNumber: number = 1) {
    this.paginationContext.CurrentPage = pageNumber
    this.moduloList = null
    const inputParams =
    {
      entidad: {
        nombre: this.filtroNombre === undefined ? "" : this.filtroNombre
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.log('inputParams', JSON.stringify(inputParams))

    this.moduloService.obtenerModulosSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.moduloList = registros;
    });
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  actualizar(operacionModuloList: operacion_moduloJoin[]) {
    this.selectedModulo.codigo = this.formulario.controls["codigo"].value;
    this.selectedModulo.nombre = this.formulario.controls["nombre"].value;
    this.selectedModulo.activado = this.formulario.controls["activado"].value;
    this.selectedModulo.categoria_modulo_codigo = this.formulario.controls["categoria_modulo_codigo"].value;
    this.selectedModulo.endpoint = this.formulario.controls["endpoint"].value;
    this.selectedModulo.orden = this.formulario.controls["orden"].value;
    this.selectedModulo.habilitar_bloqueo = this.formulario.controls["habilitar_bloqueo"].value;
    this.refrescar(this.selectedModulo);
    this.refrescarOperacion(operacionModuloList);
  }

  refrescar(modulo: modulo) {
    delete modulo["__typename"];
    const inputParams = {
      entidad: modulo
    }
    this.log('inputParams', JSON.stringify(inputParams))
    this.moduloService.modificar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.onSuccess.emit()
      this.toastService.success('Operación exitosa')
      this.buscar(this.paginationContext.CurrentPage)
    })
  }

  cambiaEstado(modulo: modulo) {
    if (modulo.activado) {
      modulo.activado = false;
    }
    else {
      modulo.activado = true;
    }
    this.refrescar(modulo);
  }

  obtenerOperacion() {
    let self = this;
    this.client.query({
      query: gql`
      query {
        operacion{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                nombre
                descripcion
                activado
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.operacionList = respuesta.data.operacion.obtenerTodos.respuesta.registros;
      self.optionsOperacion = [];
      var sel: any;
      self.operacionList.forEach(element => {
        if (element.activado == true) {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsOperacion.push(sel);
        }
      });
    });
  }

  obtenerOperacionModulo(codigo_modulo: number) {
    let self = this;
    self.client.query({
      query: gql`
      query($codigo_modulo:Decimal){
        operacion_modulo{
          obtenerOperacionxModulo(codigo_modulo:$codigo_modulo){
            respuesta{
              registros{
                modulo_codigo
                modulo_nombre
                operacion_codigo
                operacion_nombre
                fecha_creacion
                activado
              }
            }
          }
        }
      }
      `,
      variables: {
        "codigo_modulo": codigo_modulo
      },
      fetchPolicy: 'no-cache',
    },
      function (respuesta) {
        self.operacionModuloList = respuesta.data.operacion_modulo.obtenerOperacionxModulo.respuesta.registros;
      });
  }

  agregarOperacion() {
    let modulo_codigo = this.formulario.controls["codigo"].value;
    let modulo_nombre = this.formulario.controls["nombre"].value;
    let operacion_codigo = this.formulario.controls["operacion"].value;
    let operacion_nombre = "";
    let fecha_creacion = new Date();

    var sel: any;
    var arr = [];
    if (operacion_codigo.toString() == "") {
      return;
    }
    this.operacionList.forEach(element => {
      if (element.codigo == this.formulario.controls["operacion"].value) {
        operacion_nombre = element.nombre;
        fecha_creacion = element.fecha_creacion;
      }
    });

    for (let item of this.operacionModuloList) {
      arr = [item["operacion_codigo"], item["operacion_nombre"]];
      var idx = arr.indexOf(operacion_codigo);
      if (idx != -1) {
        return;
      }
    }
    sel = { modulo_codigo, modulo_nombre, operacion_codigo, operacion_nombre, fecha_creacion };
    this.operacionModuloList.push(sel);
  }

  eliminarOperacion(index) {
    this.operacionModuloList.splice(index, 1);
  }

  insertarOperacion(operacionModuloList: operacion_moduloJoin[], codigo_modulo: number) {
    for (var i = 0; i < operacionModuloList.length; i++) {
      operacionModuloList[i].modulo_codigo = codigo_modulo;
      delete operacionModuloList[i]["__typename"];
      delete operacionModuloList[i].modulo_nombre;
      delete operacionModuloList[i].operacion_nombre;
      delete operacionModuloList[i].fecha_creacion;
      delete operacionModuloList[i].activado;
    }
    let self = this;
    var bodyx = operacionModuloList;
    this.client.mutate({
      mutation: gql`
      mutation($entidad:operacion_moduloListInputType, $codigo_modulo:Decimal){
        operacion_modulo{
          guardarOperacionxModulo(entidad:$entidad, codigo_modulo:$codigo_modulo){
            mensajes{
              codigo
              tipo
              contexto
              texto
            }  
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet": bodyx
        },
        "codigo_modulo": codigo_modulo
      }
    },
      function (mensajes) {
        if (mensajes.data.operacion_modulo.guardarOperacionxModulo.mensajes != undefined) {
          setTimeout(() => self.obtenerOperacionModulo(codigo_modulo), 1000);
        }
      });
  }

  refrescarOperacion(operacionModuloList: operacion_moduloJoin[]) {
    let codigo_modulo = this.formulario.controls["codigo"].value;
    for (var i = 0; i < operacionModuloList.length; i++) {
      delete operacionModuloList[i]["__typename"];
      delete operacionModuloList[i].modulo_nombre;
      delete operacionModuloList[i].operacion_nombre;
      delete operacionModuloList[i].fecha_creacion;
      delete operacionModuloList[i].activado;
    }
    let self = this;
    var bodyx = operacionModuloList;
    this.client.mutate({
      mutation: gql`
      mutation($entidad:operacion_moduloListInputType, $codigo_modulo:Decimal){
        operacion_modulo{
          guardarOperacionxModulo(entidad:$entidad, codigo_modulo:$codigo_modulo){
            mensajes{
              codigo
              tipo
              contexto
              texto
            }  
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet": bodyx
        },
        "codigo_modulo": codigo_modulo
      }
    },
      function (mensajes) {
        if (mensajes.data.operacion_modulo.guardarOperacionxModulo.mensajes != undefined) {
          setTimeout(() => self.obtenerOperacionModulo(codigo_modulo), 1000);
        }
      });
  }
  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(modulo: modulo) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(modulo);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
